import ApiService from './api.service';

export default class Pose {
  static async fetchPosesTypes(params) {
    const poses = await ApiService.get('/resources/poses', {
      params,
    });

    return poses;
  }

  static async findPoseType(poseId) {
    return ApiService.get(`/resources/poses/${poseId}`);
  }

  static async deletePoseType(poseId) {
    return ApiService.delete(`/resources/poses/${poseId}`);
  }

  static async createPoseType(pose) {
    return ApiService.post('/resources/poses', pose);
  }

  static async updatePoseType(pose) {
    const { id } = pose;
    delete pose.id;

    return ApiService.put(`/resources/poses/${id}`, pose);
  }
}
